module.exports = __webpack_public_path__ + "img/aviator22.93ef176a.png";